<template>
  <div class="referrerInfor">
    <!-- 搜索框 -->
    <SearchBar @search="search" :checkList="checkList" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <!-- <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column> -->
      <el-table-column label="推荐人姓名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="推荐人电话" align="center">
        <template slot-scope="scope">
          {{
            maskPhoneNumberFun(
              handledecrypt(scope.row.mobile),
              scope.row.isShowAllPhone
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column label="身份证后六位" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.lastSixId || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推荐物业数量" align="center">
        <template slot-scope="scope">
          {{ scope.row.pmcNumber || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="注册时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.creationTime || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人状态" align="center">
        <template slot-scope="scope">
          {{ statusObj[scope.row.status].label }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
  </div>
</template>

<script>
import { getpmcStatisticstListApi } from '@/api/referrer';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import SearchBar from './components/searchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';
import { maskPhoneNumber } from '@/utils/index';
export default {
  components: {
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      checkList: [], // 选中的列表
      statisticsData: {}, // 统计数据
      statusObj: {
        0: {
          label: '正常',
        },
        1: {
          label: '已冻结',
        },
        2: {
          label: '已注销',
        },
      },
    };
  },
  created() {
    this.fetchData();
  },

  computed: {
    ...mapGetters(['paginObj']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    maskPhoneNumberFun(str, isShowAllPhone) {
      if (isShowAllPhone) return str;
      return maskPhoneNumber(str);
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        this.listLoading = true;
        let res = await getpmcStatisticstListApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj && Object.keys(obj).length) this.fromSearchObj = obj;
      console.log('拿到：', obj, this.fromSearchObj);
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    // 勾选导出
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
  },
};
</script>

<style lang="less">
.referrerInfor {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 20px;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 60px;
  line-height: 60px;
  text-align: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
